import React from 'react'
import { useNavigate, Link } from 'react-router-dom';
import { UserAuth } from '../../context/AuthContext'
import { BsTropicalStorm } from 'react-icons/bs';
import { HiOutlineBell } from 'react-icons/hi';

const NavHeader = () => {
    const { logout } = UserAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
            console.log('You are logged out');
        } catch (e) {
            console.log(e.message)
        }
    }
    return (
        <div className='bg-gradient-to-r from-primary to-blue-700 md:bg-gradient-to-r md:from-white md:to-white max-w-[600px] mx-auto top-0 fixed left-0 right-0 md:shadow-bottom md:border-b z-10'>
            <div className="py-2 px-4 md:py-2 md:px-4 mx-auto flex justify-between">
                <Link to="/">
                <div className="flex">
                    <span className='mr-2 mt-1'><BsTropicalStorm size='24' className='md:text-black text-white'/></span>
                    <span className='text-xl font-medium md:text-black text-white'>IziUSE</span>
                </div>
                </Link>
                <div className="flex justify-center items-center">
                    <Link onClick={handleLogout} className="px-3 text-sm font-medium  hover:text-indigo-600 transition duration-150 ease-in-out md:text-gray-800 text-white" to="#">Logout</Link>
                    <HiOutlineBell className='text-white' size='24px' />
                </div>
            </div>
        </div>
    )
}

export default NavHeader